import { useContext, useEffect } from "react";
import { EntityContext } from "../../../../contexts/EntityContext";
import {
  getLocalStorageData,
  clearLocalStorageData,
} from "../../../../shared/utils/localStorage";
import {  Grid, Typography } from "@mui/material";
import useQuery from "../../../../shared/components/hooks/useQuery";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import StudentCard from "../studentCardView";
import { ViewContainer } from "../../../../shared/components/viewContainer";


const Dashboard = () => {
  const { setEntityName } = useContext(EntityContext);
  const navigate = useNavigate();
  const { payload } = useContext(SidebarContext);

  useEffect(() => {
    getLocalStorageData("token");
    setEntityName({ entityName: "Dashboard", entityTitle: "Dashboard" });
  }, [setEntityName]);

  useEffect(() => {
    const token = getLocalStorageData("token");
    if (!token) {
      clearLocalStorageData();
      window.location.href = "/login";
    }
  }, []);

  interface StudentClass {
    class?: {
      displayName?: string;
    };
    rollNumber?: string;
  }

  interface Student {
    id: string | number;
    name: string;
    studentClass?: StudentClass[];
  }

  const { loading, data, error } = useQuery("/parent-students", {
    params: { ...payload },
  });

    const studentData = (data as any)?.items || [];
    
  //  const titleBar: TitleBarProps = {
  //     title: "Dashboard",
  //   };
  return (
   <ViewContainer >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Welcome, Parent
              </Typography>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <Grid container spacing={2}>
          {studentData.map((student:any) => {
            const studentName = student.name || "N/A";
            const studentClass = student.studentClass?.[0];
            const displayName = studentClass?.class?.displayName || "N/A";
            const rollNumber = studentClass?.rollNumber || "N/A";
            return (
              <Grid item xs={6} sm={4} md={2} key={student.id}>
                <StudentCard
                 studentId={student.id}
                  name={student.name}
                  rollNumber={rollNumber}
                  displayName={displayName}
                />
              </Grid>
            );
          })}
        </Grid>
      )}
      </ViewContainer>
  );
};

export default Dashboard;